export const title = "Invite a Friend";

export const description =
  "Our program involves working in a circle. We suggest inviting someone you already know and like, who can help you meet a goal. You will help them meet a goal, too.";

export const successTitle = "Your Friend Was Invited";

export const successDescription =
  "An email was sent to your friend with an invitation to join Pollinator for free.";

export const deletionTitle = "Delete Invitation";

export const deletionDescription =
  "You can invite up to 1 friend to participate in Pollinator with you, for free. Manage your existing invite below.";
